var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowerVine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m-106.3,1471.11c88.89,72.22 264.81,170.37 305.56,27.78c40.74,-142.59 -46.3,-290.74 -70.37,-368.52c-24.07,-77.78 -75.93,-322.22 -55.56,-416.67c20.37,-94.44 109.26,-164.81 162.96,-198.15c53.7,-33.33 185.19,-83.33 295.19,-54.44c110,28.89 164.07,89.63 202.96,165.56c38.89,75.93 7.41,135.19 -21.48,164.07c-28.89,28.89 -122.96,61.85 -159.26,153.7c-36.3,91.85 -22.96,185.93 46.3,275.93c69.26,90 134.44,126.67 232.59,115.56c98.15,-11.11 250,-105.56 392.59,-162.96c142.59,-57.41 301.85,-57.41 437.04,-31.48c135.19,25.93 322.22,153.7 474.07,112.96c151.85,-40.74 205.56,-103.7 285.93,-239.63c80.37,-135.93 167.78,-364.07 143.7,-458.52c-24.07,-94.44 -135.19,-138.89 -180.74,-198.89c-45.56,-60 -45.19,-132.59 -60,-188.15c-14.81,-55.56 -53.7,-133.33 -72.22,-168.52c-18.52,-35.19 -64.81,-77.78 -157.41,-72.22c-92.59,5.56 -138.89,124.07 -153.7,185.19c-14.81,61.11 -29.63,144.44 -94.44,237.04c-64.81,92.59 -118.52,135.19 -177.78,168.52c-59.26,33.33 -90.74,42.59 -153.7,51.85c-62.96,9.26 -135.19,12.96 -179.63,68.52c-44.44,55.56 -33.33,159.26 -90.74,194.44c-57.41,35.19 -185.19,51.85 -285.19,-40.74c-100,-92.59 -150,-246.3 -134.44,-348.89c15.56,-102.59 54.81,-177.04 123.33,-219.63c68.52,-42.59 140.74,-74.07 179.63,-127.78c38.89,-53.7 18.52,-175.93 155.56,-181.48c137.04,-5.56 300,120.37 298.89,-248.89c-1.11,-369.26 -876.67,148.89 -877.78,150c-1.11,1.11 -902.59,119.26 -904.44,119.26c-1.85,0 92.59,1535.19 92.59,1535.19z",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_17",
    stroke: "#000000",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerVine1);
export default __webpack_public_path__ + "static/media/followerVine1.cf41887870e796efce80801138499701.svg";
export { ForwardRef as ReactComponent };